export default "__VITE_ASSET__QE6wNoAI__"